import { useEffect, useState } from "react";
import { Play, X } from "lucide-react";

const SECONDS = 10;

export default function NextUp({ episode, onPlay, onCancel }) {
  const [left, setLeft] = useState(SECONDS);
  useEffect(() => {
    if (left <= 0) {
      onPlay();
      return;
    }
    const t = setTimeout(() => setLeft((x) => x - 1), 1000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [left]);
  return (
    <div className="absolute bottom-16 right-6 z-10 w-80 rounded-2xl bg-black/80 backdrop-blur-md border border-white/10 p-4 xc-rise" data-testid="next-up-overlay">
      <div className="flex items-start gap-3">
        <div className="w-24 aspect-video rounded-lg overflow-hidden bg-[#1A1E2E] shrink-0">
          {episode.info?.movie_image && <img src={episode.info.movie_image} alt="" className="w-full h-full object-cover" onError={(e) => (e.currentTarget.style.display = "none")} />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="xc-label text-[#00E5FF]">Up next in <span data-testid="next-up-countdown">{left}</span>s</div>
          <div className="text-sm font-medium truncate mt-1" data-testid="next-up-title">{episode.title}</div>
        </div>
      </div>
      <div className="h-1 rounded-full bg-white/10 mt-3 overflow-hidden">
        <div className="h-full bg-[#E50914] transition-[width] duration-1000 ease-linear" style={{ width: `${((SECONDS - left) / SECONDS) * 100}%` }} />
      </div>
      <div className="flex gap-2 mt-3">
        <button onClick={onPlay} className="xc-btn-primary !py-1.5 text-sm flex-1 justify-center" data-testid="next-up-play-button">
          <Play className="w-3.5 h-3.5 fill-white" /> Play now
        </button>
        <button onClick={onCancel} className="xc-btn-ghost !py-1.5 text-sm" data-testid="next-up-cancel-button">
          <X className="w-3.5 h-3.5" /> Cancel
        </button>
      </div>
    </div>
  );
}
